module.exports = __webpack_public_path__ + "img/close.6d9693e7.svg";